var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('v-toolbar',{attrs:{"flat":"","color":"grey lighten-5"}},[_c('breadcrumbs'),_c('v-spacer'),_vm._t("actionButton")],2),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }